"use strict"

do ($=jQuery, win=@window, doc=@document) ->

  $win = $(win)
  $doc = $(doc)
  # resizeend
  rtime = undefined
  timeout = false
  delta = 200

  canvas = undefined
  context = undefined
  wave1 = []
  wave2 = []
  wave3 = []
  mouse =
    x: win.innerWidth * 0.5
    y: win.innerHeight * 0.5

  angle = 0
  #mouseDown = interactive = true
  mouseDown = true
  interactive = true
  #FPS = 60
  offset = $("body").offset()

  # * Distance between two wave1.
  distanceTo = (pointA, pointB) ->
    dx = Math.abs(pointA.x - pointB.x)
    dy = Math.abs(pointA.y - pointB.y)
    Math.sqrt dx * dx + dy * dy

  # * Checks if browser supports canvas element.
  capable = -> canvas.getContext and canvas.getContext("2d")

  # * Mouse down event.
  onMouseDown = (event) ->
    event.preventDefault()
    mouseDown = true
    #return
   
  # * Mouse up event.
  onMouseUp = (event) ->
    event.preventDefault()
    mouseDown = false
    #return
  
  # * Mouse move event.
  onMouseMove = (event) ->
    event.preventDefault()
    mouse.x = event.pageX - offset.left   # canvas.offsetLeft
    mouse.y = event.pageY - offset.top
    mouseDown = interactive = false  if interactive
    #return
  
  # * Touch start event.
  onTouchStart = (event) ->
    event.preventDefault()
    mouseDown = true
    #return

  # * Touch end event.
  onTouchEnd = (event) ->
    event.preventDefault()
    mouseDown = false
    #return

  # * Touch move event.
  onTouchMove = (event) ->
    event.preventDefault()
    mouse.x = event.touches[0].pageX - offset.left
    mouse.y = event.touches[0].pageY - offset.top
    mouseDown = interactive = false  if interactive
    #return

  # * On resize win event.
  onResize = ->
    clear()
    cancelAnimationFrame wave
    $("canvas.wavecanv").remove()
    canvas = undefined
    context = undefined
    wave1 = []
    wave2 = []
    wave3 = []
    init()
    #console?.info "canvas.width:", canvas.width       #------- sw Log --(´･_･`)

  # * Clear the whole screen.
  clear = -> context.clearRect 0, 0, win.innerWidth, win.innerHeight

  # * Update the waves.
  update = ->
    ease = undefined
    friction = undefined
    threshold = undefined
    friction = 0.99
    threshold = (if interactive then Math.round(canvas.width / 4.5) else 280)
    if interactive
      angle += 0.05
      mouse.x = canvas.width * 0.5 + Math.sin(angle) * canvas.width * 0.2
      mouse.y = (canvas.height * 0.5 - 50) + Math.sin(angle) * canvas.height * 0.2

    index = 0
    while index < (wave1.length or wave2.length or wave3.length)
      point1 = wave1[index]
      point2 = wave2[index]
      point3 = wave3[index]

      # fixme 整数化が必要?
      point1.y += point1.vy | 0
      point2.y += point2.vy | 0
      point3.y += point3.vy | 0
      
      # Ease
      point1.vy += (point1.depth - point1.y) * ((if interactive then 0.003 else 0.009))
      point2.vy += (point2.depth - point2.y) * ((if interactive then 0.02 else 0.0008))
      point3.vy += (point3.depth - point3.y) * ((if interactive then 0.01 else 0.017))
      
      # Friction
      point1.vy *= friction
      point2.vy *= friction
      point3.vy *= friction
      
      # Threshold
      point1.vy += ~~( (mouse.y - point1.y) * ((if interactive then 0.03 else 0.009)) )  if distanceTo(mouse, point1) < threshold and mouseDown
      point2.vy += ~~( (mouse.y - point2.y) * ((if interactive then 0.02 else 0.008)) )  if distanceTo(mouse, point2) < threshold and mouseDown
      point3.vy += ~~( (mouse.y - point3.y) * ((if interactive then 0.01 else 0.007)) )  if distanceTo(mouse, point3) < threshold and mouseDown
      index++
    return
  
  # * Render the waveS.
  render = ->
    wave = 0
    while wave < (wave1.length or wave2.length or wave3.length)
      # Smooth bezier curves
      clear()
      context.save()
      context.globalAlpha = 0.33
      context.fillStyle = "#f98f00"
      context.beginPath()
      context.moveTo wave1[0].x, wave1[0].y
      
      # Draw through N wave1
      N = 1
      while N < wave1.length - 2
        xc = (wave1[N].x + wave1[N + 1].x) / 2
        yc = (wave1[N].y + wave1[N + 1].y) / 2
        context.quadraticCurveTo wave1[N].x, wave1[N].y, xc, yc
        N++

      context.quadraticCurveTo wave1[wave1.length - 2].x, wave1[wave1.length - 2].y, wave1[wave1.length - 1].x, wave1[wave1.length - 1].y
      context.lineTo canvas.width, canvas.height
      context.lineTo 0, canvas.height
      context.lineTo 0, wave1[0].y
      context.fill()
      context.restore()
      context.save()
      context.globalAlpha = 0.3
      context.fillStyle = "#00fddc"
      context.beginPath()
      context.moveTo wave2[0].x, wave2[0].y
      
      # Draw through N wave2
      N = 1
      while N < wave2.length - 2
        xc = (wave2[N].x + wave2[N + 1].x) / 2
        yc = (wave2[N].y + wave2[N + 1].y) / 2
        context.quadraticCurveTo wave2[N].x, wave2[N].y, xc, yc
        N++

      context.quadraticCurveTo wave2[wave2.length - 2].x, wave2[wave2.length - 2].y, wave2[wave2.length - 1].x, wave2[wave2.length - 1].y
      context.lineTo canvas.width, canvas.height
      context.lineTo 0, canvas.height
      context.lineTo 0, wave2[0].y
      context.fill()
      context.restore()
      context.save()
      context.globalAlpha = 0.25
      context.fillStyle = "#05cdf8"
      context.beginPath()
      context.moveTo wave3[0].x, wave3[0].y
      
      # Draw through N wave3
      N = 1
      while N < wave3.length - 2
        xc = (wave3[N].x + wave3[N + 1].x) / 2
        yc = (wave3[N].y + wave3[N + 1].y) / 2
        context.quadraticCurveTo wave3[N].x, wave3[N].y, xc, yc
        N++

      context.quadraticCurveTo wave3[wave3.length - 2].x, wave3[wave3.length - 2].y, wave3[wave3.length - 1].x, wave3[wave3.length - 1].y
      context.lineTo canvas.width, canvas.height
      context.lineTo 0, canvas.height
      context.lineTo 0, wave3[0].y
      context.fill()
      context.restore()
      wave++

    return

  # * Loop logic.
  wave = ->
    clear()
    update()
    render()
    timerID = requestAnimationFrame wave
    #return

  # * Create waves.
  createWaves = ->
    totalPoints = Math.round(canvas.width / 234)

    quantity = 0
    len = totalPoints
    while quantity < len
      # First wave
      wave1.push
        x: canvas.width * quantity / (len - 1)
        y: canvas.height * 0.5 - 20
        vy: Math.random() * 10
        depth: canvas.height * 0.5
      quantity++

    quantity = 0
    len = totalPoints
    while quantity < len
      # Second wave
      wave2.push
        x: canvas.width * quantity / (len - 1)
        y: canvas.height * 0.5
        vy: Math.random() * 10
        depth: canvas.height * 0.5
      quantity++

    quantity = 0
    len = totalPoints
    while quantity < len
      # Third wave
      wave3.push
        x: canvas.width * quantity / (len - 1)
        y: canvas.height * 0.5 + 20
        vy: Math.random() * 10
        depth: canvas.height * 0.5
      quantity++

    wave()
    return

  # * Init.
  init = ->
    body = document.querySelector("body")
    canvas = document.createElement("canvas")
    canvas.className = "wavecanv"
    canvas.width = win.innerWidth
    canvas.height = win.innerHeight
    canvas.style.position = "absolute"
    canvas.style.top = 0
    canvas.style.bottom = 0
    canvas.style.left = 0
    canvas.style.right = 0
    canvas.style.zIndex = -1
    canvas.style.cursor = "n-resize"
    body.appendChild canvas

    # Browser supports canvas?
    unless not (capable)
      context = canvas.getContext("2d")
      # Events
      listener = $("body") #.find("div.t") #canvas $win

      #if "ontouchmove" of win
      # スマホからのアクセス
      if (doc.ontouchstart isnt undefined) or (doc.createTouch isnt undefined)
        listener.on "touchstart", (e)-> onTouchStart(e)
        listener.on "touchend", (e)->   onTouchEnd(e)
        listener.on "touchmove", (e)->  onTouchMove(e)
        #listener.addEventListener "touchstart", onTouchStart, false
        #listener.addEventListener "touchend",   onTouchEnd, false
        #listener.addEventListener "touchmove",  onTouchMove, false
      else
        listener.on "mousedown", (e)-> onMouseDown(e)
        listener.on "mouseup", (e)->   onMouseUp(e)
        listener.on "mousemove", (e)-> onMouseMove(e)
        #listener.addEventListener "mousedown",  onMouseDown, false
        #listener.addEventListener "mouseup",    onMouseUp, false
        #listener.addEventListener "mousemove",  onMouseMove, false

      resizeend = ->
        if new Date - rtime < delta
          setTimeout resizeend, delta
        else
          timeout = false
          onResize()
        return

      $win.resize (e)->
        rtime = new Date
        if timeout == false
          timeout = true
          setTimeout resizeend, delta
        return

      #$win.on "resize", (e)-> onResize(e)
      #win.onresize = onResize

      createWaves()
    else
      console.error "Please, update your browser for seeing this animation."
    return

  ### RequestAnimationFrame shim. ###
  do ->
    time = 0
    vendors = ['ms', 'moz', 'webkit', 'o']
    for vendor in vendors when not win.requestAnimationFrame
        win.requestAnimationFrame = win[ vendor + 'RequestAnimationFrame']
        win.cancelRequestAnimationFrame = win[ vendor + 'CancelRequestAnimationFrame']

    if not win.requestAnimationFrame
        win.requestAnimationFrame = (callback, element) ->
            now = new Date().getTime()
            delta = Math.max 0, 16 - (now - old)
            setTimeout (-> callback(time + delta)), delta
            old = now + delta

    if not win.cancelAnimationFrame
        win.cancelAnimationFrame = (id) -> clearTimeout id
    
  # Do it Animation init
  init()


  # * Request new frame by Paul Irish.
  # * 60 FPS.
  ###win.requestAnimationFrame = (->
    win.requestAnimationFrame or win.webkitRequestAnimationFrame or win.mozRequestAnimationFrame or
    win.oRequestAnimationFrame or win.msRequestAnimationFrame or (callback) ->
      win.setTimeout callback, 1000 / FPS
      return
  )()###
  #(if win.addEventListener then win.addEventListener("load", init, false) else win.onload = init)
